import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { AuthenticationService, ContactApiService } from '../data-services/index';
import { IContact, IUser } from '@ebb-v2/ebb-integration';

export interface IUserApp {
  userId: string;
  appId: string;
}

@Component({
  selector: 'ebb-portal-authorization',
  templateUrl: './authorization.component.html'
})
export class AuthorizationComponent implements OnInit {
  public currentUser: IUser = {} as IUser;

  constructor(
    private actRoute: ActivatedRoute,
    private router: Router,
    private apiAuthentication: AuthenticationService,
    private apiContact: ContactApiService
  ) { }

  ngOnInit() {
    this.actRoute.queryParamMap
    .subscribe(params => {
      const nonceCheck = params.get('nonce');
      this.apiAuthentication.getCurrentAuthentication().subscribe(user => {
        if(user){
          this.setCurrentUser(user.email);
        } else {
          this.router.navigate(['login']);
        }
      });
    });
  }

  private setCurrentUser(userEmail: string): void {
    this.apiContact
      .getContact()
      .subscribe(
        data => { 
          if (data) {
            this.currentUser.id = data.id;
            this.currentUser.fullName = data.fullName;
            this.currentUser.needsProfileUpdate = !data.firstName || !data.lastName;
            this.currentUser.email = data.emailAddress1;
            this.currentUser.isHomeowner = data.isHomeowner;
            this.currentUser.isContractor = data.isContractor;
            this.currentUser.isEngineer = data.isEngineer;
            this.currentUser.isInspector = data.isInspector;
            this.currentUser.mode = this.apiAuthentication.defaultUserMode(this.currentUser);
            this.apiAuthentication.setCurrentUserValue(this.currentUser);
            setTimeout(() =>
            {
              this.router.navigate(['home']);
            }, 1500);
          } else {
            this.router.navigate(['login']);
            console.warn(`Login error: contact not found`);
          }
          
        },
        error => {
          this.router.navigate(['login'], { queryParams: { error: true } });
          console.warn(`Login error: ${error}`);
        }
      )
  }

}
